export default __webpack_public_path__ + "static/media/trello3.22398620.png";